/**
 * @generated SignedSource<<547b41b23261da1dab3e0f13d0450b94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PollItemRefetchQuery$variables = {
  id: string;
};
export type PollItemRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"PollItem_poll">;
  } | null;
};
export type PollItemRefetchQuery = {
  variables: PollItemRefetchQuery$variables;
  response: PollItemRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PollItemRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PollItem_poll"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PollItemRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MoneyAmount",
                "kind": "LinkedField",
                "name": "reward",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "formatted",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "QuestionDescription",
                "kind": "LinkedField",
                "name": "description",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PollQuestion",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25b2f4ab4c4974af8a2b6f280e4442b1",
    "id": null,
    "metadata": {},
    "name": "PollItemRefetchQuery",
    "operationKind": "query",
    "text": "query PollItemRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...PollItem_poll\n    id\n  }\n}\n\nfragment PollHeader_data on PollQuestion {\n  id\n  description {\n    title\n  }\n  reward {\n    formatted\n  }\n  startDate\n}\n\nfragment PollItem_poll on PollQuestion {\n  id\n  startDate\n  reward {\n    formatted\n  }\n  description {\n    title\n  }\n  ...PollHeader_data\n}\n"
  }
};
})();

(node as any).hash = "9f4edff1efc8e04f0c66a981c1756535";

export default node;
